export const CarrierValidator = () => ({
  carrier: "",
  error: "",
  isValid: true,
  validationMessages: null,
  isDefault: false,

  init() {
    this.carrier = this.$refs.carrierInput.value
    this.isDefault = this.$el.querySelector('input[type="checkbox"]')?.checked || false

    try {
      const messagesAttr = this.$el.getAttribute("data-validation-messages")
      if (messagesAttr) {
        this.validationMessages = JSON.parse(messagesAttr)
      }
    } catch (e) {
      console.error("Cannot parse carrier validation messages.", e)
    }

    this.validate()

    this.$nextTick(() => {
      this.$dispatch("carrier-validation-changed", { isValid: this.isValid, isDefault: this.isDefault })
    })
  },

  changeCarrier() {
    let inputValue = this.$refs.carrierInput.value

    let uppercaseValue = inputValue.toUpperCase()

    this.$refs.carrierInput.value = uppercaseValue

    this.carrier = uppercaseValue

    this.validate()

    this.$dispatch("carrier-validation-changed", { isValid: this.isValid, isDefault: this.isDefault })
  },

  toggleDefault() {
    this.isDefault = !this.isDefault
    this.validate()

    this.$dispatch("carrier-validation-changed", { isValid: this.isValid, isDefault: this.isDefault })
  },

  validate() {
    this.isValid = true
    this.error = ""

    if (this.isDefault && (!this.carrier || this.carrier.trim() === "")) {
      this.error = "預設選項不能為空"
      this.isValid = false
      return
    }

    if (!this.isDefault && (!this.carrier || this.carrier.trim() === "")) {
      return
    }

    if (this.carrier && this.carrier.trim() !== "") {
      const carrierRegex = /^\/[A-Z0-9.\-+]{7}$/

      if (!carrierRegex.test(this.carrier)) {
        this.error = this.validationMessages?.carrier?.format
        this.isValid = false
      }
    }
  },
})
